import React, { Component } from 'react'

import { Container, Row, Col } from '../../../../../SPRINTA/v2/atoms/Grid'
import Display from '../../../../../SPRINTA/v2/atoms/Display'
import Button from '../../../../../SPRINTA/v2/atoms/Button'
import Loading from '../../../../../SPRINTA/v2/atoms/Loading'
import { userChallenges } from '../../../../utils/challenge'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import style from './style.css'

class Challenges extends Component {

    state = {
        loading: true,
        loadingMore: false,
        challenges: {
            total: null,
            result: []
        }
    }

    componentWillMount() {
        this.loadMedals()
    }
    
    loadMedals() {
        this.setState({
            loadingMore: true
        })
        userChallenges(this.props.userData.profile.id, {
            start: this.state.challenges.result.length,
            limit: 16
        })
        .then(resp => {
            this.setState({
                loading: false,
                loadingMore: false,
                challenges: { 
                    ...this.state.challenges,
                    result: [
                        ...this.state.challenges.result,
                        ...resp.result
                    ],
                    total: resp.total
                }
            })
        })
    }

    render() {
        if(this.state.loading)
        return(
            <Container>
                <Row>
                <Col>
                    <Placeholder type='retangle' style={{width: '200px', marginTop: '20px', height: '40px'}} />
                    <Row>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                        <Col size='3 1-8'>
                            <Placeholder type='retangle' style={{marginTop: '30px', height: '200px'}} />
                        </Col>
                    </Row>
                    <br />
                </Col>
                </Row>
            </Container>
        )
        
        return (
            <Container style={{ 
                marginTop: '30px',
                marginBottom: '30px'
            }}>
                <Row>
                    <Col size='12' spacing={1}>
                        <Display size={2} style={{
                            color: '#666',
                            fontSize: '3rem'
                        }}>
                            Galeria de <b>desafios ({this.state.challenges.total})</b>
                        </Display>
                    </Col>
                </Row>

                <Row alignItems='center'>
                    {this.state.challenges.result.map(challenge => (
                        <Col key={challenge.token} size='3 1-8'>
                            <a className={!challenge.won ? style.pb : null} href={`/challenge/${challenge.token}`}>
                                <img src={challenge.medal} alt={challenge.title} style={{ maxWidth: '100%' }} />
                            </a>
                        </Col>
                    ))}
                </Row>

                {this.state.challenges.total > this.state.challenges.result.length && (
                    <Row>
                        <Col size='12' text='center'>
                            {this.state.loadingMore ? (
                                <Loading />
                            ) : (
                                <Button inline primary onClick={() => this.loadMedals()}>Carregar mais</Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>
        )
    }
}

export default Challenges


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Challenges/index.js